import { RouteObject } from "react-router-dom";
import { lazy } from "react";

const HomePage = lazy(() => import("../pages/home/page"));
const AboutPage = lazy(() => import("../pages/about/page"));
const FavoritesPage = lazy(() => import("../pages/favorites/page"));
const NotFound = lazy(() => import("../pages/NotFound"));
const ConversationStartersPage = lazy(() => import("../pages/conversation-starters/page"));
const WeeklyEventsPage = lazy(() => import("../pages/weekly-events/page"));
const GrandparentingPage = lazy(() => import("../pages/grandparenting/page"));
const FaithSpiritualityPage = lazy(() => import("../pages/faith-spirituality/page"));
const GentlemansGuidePage = lazy(() => import("../pages/gentlemans-guide/page"));
const LifeExperiencePage = lazy(() => import("../pages/life-experience/page"));
const HealthWellnessPage = lazy(() => import("../pages/health-wellness/page"));
const RelationshipsPage = lazy(() => import("../pages/relationships/page"));
const LoginPage = lazy(() => import("../pages/auth/login/page"));
const SignupPage = lazy(() => import("../pages/auth/signup/page"));
const DashboardPage = lazy(() => import("../pages/dashboard/page"));
const PremiumPage = lazy(() => import("../pages/premium/page"));
const DatePlannerPage = lazy(() => import("../pages/date-planner/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/favorites",
    element: <FavoritesPage />,
  },
  {
    path: "/conversation-starters",
    element: <ConversationStartersPage />,
  },
  {
    path: "/weekly-events",
    element: <WeeklyEventsPage />,
  },
  {
    path: "/grandparenting",
    element: <GrandparentingPage />,
  },
  {
    path: "/faith-spirituality",
    element: <FaithSpiritualityPage />,
  },
  {
    path: "/gentlemans-guide",
    element: <GentlemansGuidePage />,
  },
  {
    path: "/life-experience",
    element: <LifeExperiencePage />,
  },
  {
    path: "/health-wellness",
    element: <HealthWellnessPage />,
  },
  {
    path: "/relationships",
    element: <RelationshipsPage />,
  },
  {
    path: "/auth/login",
    element: <LoginPage />,
  },
  {
    path: "/auth/signup",
    element: <SignupPage />,
  },
  {
    path: "/dashboard",
    element: <DashboardPage />,
  },
  {
    path: "/premium",
    element: <PremiumPage />,
  },
  {
    path: "/date-planner",
    element: <DatePlannerPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
